module.exports = __webpack_public_path__ + "img/man-border-purple.8ddb096b.svg";